import {
  upsertApiKeyRpc as anthropicApiKeyRpc,
  AnthropicAppError,
} from '../../../../__generated__/chirp/com/hubspot/anthropic/integration/rpc/AppSettingsRpc';
import {
  upsertApiKeyRpc as cohereApiKeyRpc,
  CohereAppError,
} from '../../../../__generated__/chirp/com/hubspot/cohere/integration/rpc/AppSettingsRpc';
import {
  upsertApiKeyRpc as geminiUpsertApiKeyRpc,
  GeminiAppError,
} from '../../../../__generated__/chirp/com/hubspot/gemini/integration/rpc/AppSettingsRpc';
import {
  upsertApiKeyRpc as openaiUpsertApiKeyRpc,
  OpenAIAppError,
} from '../../../../__generated__/chirp/com/hubspot/openai/integration/rpc/AppSettingsRpc';
import {
  upsertApiKeyRpc as xaiUpsertApiKeyRpc,
  XAiAppError,
} from '../../../../__generated__/chirp/com/hubspot/x/ai/integration/rpc/AppSettingsRpc';
import { chirpClient } from '../../../apiClients/chirpClient';

type TUpsertApiKeyRpc =
  | typeof anthropicApiKeyRpc
  | typeof cohereApiKeyRpc
  | typeof geminiUpsertApiKeyRpc
  | typeof openaiUpsertApiKeyRpc
  | typeof xaiUpsertApiKeyRpc;

type TAppError =
  | AnthropicAppError
  | CohereAppError
  | GeminiAppError
  | OpenAIAppError
  | XAiAppError;

const createApiKeyUpdateRequest = (upsertApiKeyRpc: TUpsertApiKeyRpc) => {
  return (request: { apiKey: string }) =>
    chirpClient
      .call(upsertApiKeyRpc, { request })
      .then((data) => {
        if ('rpcError' in data) {
          return { error: data.rpcError };
        }
        return data;
      })
      .catch((e: TAppError) => {
        return { error: e };
      });
};

export const updateAnthropicApiKey =
  createApiKeyUpdateRequest(anthropicApiKeyRpc);

export const updateCohereApiKey = createApiKeyUpdateRequest(cohereApiKeyRpc);

export const updateGeminiApiKey = createApiKeyUpdateRequest(
  geminiUpsertApiKeyRpc
);

export const updateOpenaiApiKey = createApiKeyUpdateRequest(
  openaiUpsertApiKeyRpc
);

export const updateXaiApiKey = createApiKeyUpdateRequest(xaiUpsertApiKeyRpc);
